import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import OnboardingIntro from "@/pages/OnboardingIntro";

/* =============================================================================
 * WELCOME — src/pages/Welcome.jsx, routed at /welcome, wrapped in <Protected>.
 *
 * The catch-all for the Pokémon intro. Protected (in App.jsx) sends anyone
 * here who's logged in but hasn't completed the intro yet — no matter how
 * they signed up (email through AuthEn, Google OAuth, or the login->signup
 * toggle that skips AuthEn's own intro).
 *
 * Since they already have an account, we skip the name-input scene and
 * jump straight to the welcome line using their real name.
 * ========================================================================== */

export const INTRO_DONE_KEY = "harf_intro_done";

export default function Welcome() {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const finish = () => {
    localStorage.setItem(INTRO_DONE_KEY, "1");
    nav(loc.state?.from || "/dashboard", { replace: true });
  };

  return <OnboardingIntro initialName={user?.name || ""} onComplete={finish} />;
}
